export default __webpack_public_path__ + "static/media/cross-icon.09d92367.svg";